export default `
query getBrandLogo($sku: String!){
	brand_logo(product_sku: $sku) {
	  title
	  logo
	  url_key
	}
}
`;

export interface BrandLogoQueryResponse {
  brand_logo: {
    title?: string | null;
    logo?: string | null;
    url_key?: string | null;
  };
}
